/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetNonScannableCategoriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetNonScannableCategoriesQuery = {
  getNonScannableCategories: {
    categories: Array<{
      id: string;
      name: string;
      subcategories: Array<{
        id: string;
        imageUrl: string | null;
        name: string;
        productsCount: number;
      }>;
    }>;
  };
};

export const GetNonScannableCategoriesDocument = gql`
  query getNonScannableCategories {
    getNonScannableCategories {
      categories {
        id
        name
        subcategories {
          id
          imageUrl
          name
          productsCount
        }
      }
    }
  }
`;

/**
 * __useGetNonScannableCategoriesQuery__
 *
 * To run a query within a React component, call `useGetNonScannableCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonScannableCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNonScannableCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNonScannableCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetNonScannableCategoriesQuery,
    GetNonScannableCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetNonScannableCategoriesQuery, GetNonScannableCategoriesQueryVariables>(
    GetNonScannableCategoriesDocument,
    options,
  );
}
export function useGetNonScannableCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNonScannableCategoriesQuery,
    GetNonScannableCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetNonScannableCategoriesQuery,
    GetNonScannableCategoriesQueryVariables
  >(GetNonScannableCategoriesDocument, options);
}
// @ts-ignore
export function useGetNonScannableCategoriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetNonScannableCategoriesQuery,
    GetNonScannableCategoriesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetNonScannableCategoriesQuery,
  GetNonScannableCategoriesQueryVariables
>;
export function useGetNonScannableCategoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetNonScannableCategoriesQuery,
        GetNonScannableCategoriesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetNonScannableCategoriesQuery | undefined,
  GetNonScannableCategoriesQueryVariables
>;
export function useGetNonScannableCategoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetNonScannableCategoriesQuery,
        GetNonScannableCategoriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetNonScannableCategoriesQuery,
    GetNonScannableCategoriesQueryVariables
  >(GetNonScannableCategoriesDocument, options);
}
export type GetNonScannableCategoriesQueryHookResult = ReturnType<
  typeof useGetNonScannableCategoriesQuery
>;
export type GetNonScannableCategoriesLazyQueryHookResult = ReturnType<
  typeof useGetNonScannableCategoriesLazyQuery
>;
export type GetNonScannableCategoriesSuspenseQueryHookResult = ReturnType<
  typeof useGetNonScannableCategoriesSuspenseQuery
>;
export type GetNonScannableCategoriesQueryResult = Apollo.QueryResult<
  GetNonScannableCategoriesQuery,
  GetNonScannableCategoriesQueryVariables
>;
